"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateNode = exports.StateNodeType = void 0;
const state_event_1 = require("./state-event");
const workflow_1 = require("./workflow");
const delta_1 = require("./delta");
var StateNodeType;
(function (StateNodeType) {
    StateNodeType["Auto"] = "auto";
    StateNodeType["Atomic"] = "atomic";
    StateNodeType["Compound"] = "compound";
    StateNodeType["Parallel"] = "parallel";
    StateNodeType["Final"] = "final";
    StateNodeType["History"] = "history";
})(StateNodeType = exports.StateNodeType || (exports.StateNodeType = {}));
// export type StateNodeSubscriptionCallback = (stateNode: StateNode) => void;
// export interface StateNodeSubscription {
//   callback: StateNodeSubscriptionCallback;
// }
class StateNode {
    // subscriptions: StateNodeSubscription[] = [];
    constructor(parent, config = { name: 'Untitled' }) {
        var _a, _b;
        this.path = '';
        this.states = [];
        if (parent instanceof workflow_1.Workflow) {
            this.workflow = parent;
        }
        else {
            this.parent = parent;
            this.workflow = parent.workflow;
        }
        const { states } = config, stateNodeProps = __rest(config, ["states"]);
        Object.assign(this, stateNodeProps);
        if (!config.name) {
            throw new Error(`Invalid child state name at path: ${this.path}/.`);
        }
        if ((_a = config.name) === null || _a === void 0 ? void 0 : _a.includes('/')) {
            throw new Error(`Invalid state name: ${config.name}. StateNode's cannot have a name with a forward slash characte ('/')`);
        }
        this.name = this.getUniqueSiblingName(config.name);
        this.path = `${!parent || parent instanceof workflow_1.Workflow ? '' : parent.path}/${this.name}`;
        this.workflow.pathMap.set(this.path, this);
        if (states && states.length > 0) {
            for (const stateConfig of states) {
                this.states.push(new StateNode(this, stateConfig));
            }
        }
        this.events = (_b = config === null || config === void 0 ? void 0 : config.events) === null || _b === void 0 ? void 0 : _b.map(event => event instanceof state_event_1.StateEvent ? event : new state_event_1.StateEvent(this, event));
        this.refreshType();
    }
    // subscribe(callback: StateNodeSubscriptionCallback) {
    //   this.subscriptions.push({ callback });
    //   return () => this.unsubscribe(callback);
    // }
    // unsubscribe(callback: StateNodeSubscriptionCallback) {
    //   const index = this.subscriptions.findIndex(
    //     subscription => subscription.callback === callback
    //   );
    //   if (index > -1) {
    //     this.subscriptions.splice(index, 1);
    //   }
    // }
    rename(name) {
        if (this.isDuplicateSiblingName(name)) {
            throw new Error('State names must be unique.');
        }
        this.workflow.renameStateNode(this, name);
    }
    isDuplicateSiblingName(name) {
        if (this.parent) {
            for (const sibling of this.parent.states) {
                if (sibling !== this && sibling.name === name) {
                    return true;
                }
            }
        }
        return false;
    }
    addState(stateNodeConfig, after) {
        const stateNode = new StateNode(this, stateNodeConfig || { name: 'Untitled' });
        if (after instanceof StateNode) {
            after = this.states.indexOf(after);
        }
        if (typeof after === 'number') {
            this.states.splice(after + 1, 0, stateNode);
        }
        else {
            this.states.push(stateNode);
        }
        this.workflow.history.add(new delta_1.Delta({
            type: delta_1.DeltaType.Insert,
            path: stateNode.getJsonPath(),
            newValue: stateNode.toJson()
        }));
        return stateNode;
    }
    addEvent(config) {
        if (!this.events) {
            this.events = [];
        }
        const event = new state_event_1.StateEvent(this, config);
        this.events.push(event);
        this.workflow.history.add(new delta_1.Delta({
            type: delta_1.DeltaType.Insert,
            path: event.getJsonPath(),
            newValue: event.toJson()
        }));
        return event;
    }
    findEvent(name, recursive = false) {
        const events = this.events || [];
        for (const event of events) {
            if (event.name === name) {
                return this;
            }
        }
        if (recursive) {
            for (const childStateNode of this.states) {
                const stateNode = childStateNode.findEvent(name, recursive);
                if (stateNode) {
                    return stateNode;
                }
            }
        }
    }
    remove() {
        var _a, _b, _c;
        const index = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.states.indexOf(this);
        if (typeof index === 'number' && index > -1) {
            //remove all transitions to this state node
            this.workflow.removeTransition(this.path);
            // remove state node
            const path = this.getJsonPath();
            const oldValue = this.toJson();
            (_b = this.parent) === null || _b === void 0 ? void 0 : _b.states.splice(index, 1);
            (_c = this.parent) === null || _c === void 0 ? void 0 : _c.refreshType();
            this.workflow.history.add(new delta_1.Delta({ type: delta_1.DeltaType.Delete, path, oldValue }));
        }
    }
    refreshType() {
        if (!this.type) {
            this.type = StateNodeType.Auto;
        }
        if ([StateNodeType.Atomic, StateNodeType.Auto].includes(this.type) &&
            this.states.length > 0) {
            this.type = StateNodeType.Compound;
        }
        else if ([StateNodeType.Compound, StateNodeType.Auto].includes(this.type) &&
            this.states.length === 0) {
            this.type = StateNodeType.Atomic;
        }
    }
    getUniqueSiblingName(name, originalName = name, count = 2) {
        if (this.parent) {
            for (const sibling of this.parent.states) {
                if (sibling !== this && sibling.name === name) {
                    return this.getUniqueSiblingName(`${originalName} (${count})`, originalName, count + 1);
                }
            }
        }
        return name;
    }
    getDepth() {
        if (this.parent) {
            return this.parent.getDepth() + 1;
        }
        else {
            return 0;
        }
    }
    getPathTree() {
        if (this.parent) {
            return [...this.parent.getPathTree(), this.path];
        }
        else {
            return [this.path];
        }
    }
    getJsonPath() {
        let path = this.parent ? this.parent.getJsonPath() : '';
        if (this.parent instanceof StateNode) {
            const index = this.parent.states.indexOf(this);
            if (index === -1) {
                throw new Error('Invalid state node. Cannot resolve state node in parent states.');
            }
            path += (path.length > 0 ? '.' : '') + `states[${index}]`;
        }
        return path;
    }
    toJson() {
        var _a, _b;
        return {
            name: this.name,
            type: this.type,
            isInitial: this.isInitial,
            events: (_a = this.events) === null || _a === void 0 ? void 0 : _a.map(event => event.toJson()),
            invoke: this.invoke,
            meta: this.meta,
            onEntry: this.onEntry,
            onExit: this.onExit,
            states: (_b = this.states) === null || _b === void 0 ? void 0 : _b.map(stateNode => stateNode.toJson())
        };
    }
}
exports.StateNode = StateNode;
//# sourceMappingURL=state-node.js.map